import { Node } from '../game/Node';

export class Edge {
  constructor(public node1: Node, public node2: Node) {
  }
}